'use client'

import Box from '@mui/material/Box'
import Image from 'next/image'
import { FC, ReactNode } from 'react'

import TitleAndParagraph from '@/components/TitleAndParagraph'
import TwoColumnLayout, { ColumnWrapOrder } from '@/components/TwoColumnLayout'

const Certificate: FC<{ text: ReactNode }> = ({ text }) => {
    return (
        <Box>
            <TwoColumnLayout
                leftCol={6}
                rightCol={5}
                columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}
            >
                <TitleAndParagraph
                    title={`Share positive climate impact`}
                    paragraph={<span>{text}</span>}
                />
                <Box sx={{ display: 'flex' }}>
                    <Box
                        sx={{
                            width: '100%',
                            height: '0',
                            paddingBottom: '100%',
                            position: 'relative',
                            img: {
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                top: 0,
                                bottom: 0,
                                width: '100%',
                                height: '100%',
                            },
                        }}
                    >
                        <Image
                            width={485}
                            height={486}
                            src={'/images/certificate.png'}
                            alt={'certificate'}
                        />
                    </Box>
                </Box>
            </TwoColumnLayout>
        </Box>
    )
}

export default Certificate
